import moment from 'moment'
import { protectedApi } from '../../../../../config/api.config'

import { caGet, caPatch, caPost } from './http'

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export const reservationsApi = {
  async list(params = {}) {
    return caGet('/reservations', params)
  },

  async stats() {
    return caGet('/reservations/stats')
  },

  async create(payload) {
    return caPost('/reservations', payload)
  },

  async quote(payload) {
    return caPost('/reservations/quote', payload)
  },

  async get(id) {
    return caGet(`/reservations/${id}`)
  },

  async patch(id, patch) {
    return caPatch(`/reservations/${id}`, patch)
  },

  async reprice(id, payload) {
    return caPost(`/reservations/${id}/reprice`, payload)
  },

  async cancellationSummary(id) {
    return caGet(`/reservations/${id}/cancellation-summary`)
  },

  async annuler(id, payload = {}) {
    return caPost(`/reservations/${id}/annuler`, payload)
  },

  async fetchVoucherHtml(id, lang = 'fr') {
    const { data } = await protectedApi.get(`/cartes-acces/reservations/voucher/html/${id}`, {
      params: { lang },
    })
    return data?.html || ''
  },

  async downloadVoucherPdf(id, lang = 'fr') {
    const { data } = await protectedApi.get(`/cartes-acces/reservations/voucher/pdf/${id}`, {
      responseType: 'blob',
      params: { lang },
    })
    downloadBlob(data, `voucher-ca-${id}.pdf`)
    return { voucher_generated_at: moment().toISOString() }
  },
}
